//  assets/smooth-scroll.js  {%- endcomment -%}
document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('a.scroll-down[href^="#"]').forEach(link => {
    link.addEventListener('click', e => {
      e.preventDefault();             // stop the instant jump
      const target = document.querySelector(link.hash);
      if (!target) return;

      /* adjust if you have a fixed header */
      const headerH = document.querySelector('header')?.offsetHeight || 0;
      const targetY = target.getBoundingClientRect().top + window.scrollY - headerH;

      window.scrollTo({ top: targetY, behavior: 'smooth' });
    });
  });
});
